import React, { useState, useEffect, Suspense, Fragment } from 'react'
// ** Router Import
import Router from './router/Router'

// ** Routes & Default Routes
import { getRoutes } from './router/routes'

// ** Hooks Imports
import { useLayout } from '@hooks/useLayout'
import { Alert, Button, Col } from 'reactstrap'
import { AlertCircle, X } from 'react-feather'
import { Link, useLocation } from 'react-router-dom'
import { paymentStaus, geoLocation } from '@src/views/pages/account-settings/store/index.js'
import { activeOrganization } from '@src/helper/sassHelper'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'
import FileUploadForm from '@src/views/components/file-upload-global/index'

const activeOrg = activeOrganization()

const App = () => {
  const orgId = process.env.REACT_APP_DEMO_ORGANIZATION
  const [allRoutes, setAllRoutes] = useState([])
  const [refeshApp, setefreshApp] = useState()
  const [updateExists, setUpdateExists] = useState(false)
  const paystore = useSelector(state => state.organization)

  const dispatch = useDispatch()

  const location = useLocation()

  useEffect(() => {
    const handleScroll = () => window.scrollTo(0, 0)
    handleScroll()
  }, [location])

  // ** Hooks
  const { layout } = useLayout()
  const today = moment().startOf('D').valueOf()
  useEffect(() => {
    setAllRoutes(getRoutes(layout))
  }, [layout])

  const refreshApp = () => {
    setUpdateExists(false)
    if (!refeshApp) {
      return
    }
    refeshApp.postMessage({ type: "SKIP_WAITING" })
  }

  const showRefreshUI = (e) => {
    if (e.detail) {
      setefreshApp(e.detail)
      setUpdateExists(true)
    } else {
      console.warn("No worker data found!")
    }
  }

  const [paymentFlag, setPaymentFlag] = useState(false)
  useEffect(() => {
    document.addEventListener("swUpdated", showRefreshUI, { once: true })
    if (navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener(
        //triggered by registration.claim
        "controllerchange",
        () => {
          if (updateExists) return
          setUpdateExists(true)
          console.log("controllerchange triggered, -> auto refresh!!")
          window.location.reload()
        }
      )
    }
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords

        dispatch(geoLocation({ latitude, longitude }))
      },
      (error) => {
        // display an error if we cant get the users position
        console.error('Error getting user location:', error)
      }
    )
    if (today >= activeOrg?.nextpaymentdate) {
      if (localStorage.getItem('paymentFlag')) {
        setPaymentFlag(JSON.parse(localStorage.getItem('paymentFlag')))
        dispatch(paymentStaus(JSON.parse(localStorage.getItem('paymentFlag'))))
      } else {
        setPaymentFlag(true)  
        dispatch(paymentStaus(true))
      }
    }

    if (!("Notification" in window)) {
      console.log("Browser does not support desktop notification")
    } else {
      Notification.requestPermission()
    }
  }, [])

  useEffect(() => {
    if (!paystore.paymentStausFlag) {
      localStorage.removeItem('paymentFlag')
    } else {
      localStorage.setItem('paymentFlag', true)
    }
    setPaymentFlag(paystore.paymentStausFlag)

  }, [paystore.paymentStausFlag])

  return (
    <div>
      <FileUploadForm />
      {updateExists &&
        <div className='app-refresh-box'>
          <Alert color='bg-waring' isOpen={updateExists} className='bg-success'>
            <div className='alert-body'>
              <AlertCircle size={15} />{' '}
              New version Available, Click Refresh {'  '}
              <Button size='sm' color='primary' onClick={() => { refreshApp() }}>Refresh</Button>
            </div>
          </Alert>
        </div>
      }
      <Suspense fallback={null}>
        {(activeOrg && orgId !== activeOrg.id) &&
          <Fragment>
            {(paymentFlag) &&
              <Col lg={12} className='billing-notification-bar'>
                <Col lg={12} sm={12} className='text-center font-small-3'>
                  <Alert color='warning' className='p-50 mb-0 d-flex justify-content-center align-items-center'>
                    <p></p>
                    <p>
                      Your {moment().format('MMMM')} month Bill has been generated for Current Month.</p>
                    {(parseInt(activeOrg?.rolelevel) === 1 || parseInt(activeOrg?.rolelevel) === 2) && <Fragment><p className='m-0'>Click here to</p> <Link to={`/settings/billing`} className='ms-50 text-decoration-underline'>Pay Now</Link></Fragment>}
                  </Alert>
                </Col>
              </Col>
            }
          </Fragment>
        }
        <Router allRoutes={allRoutes} />
      </Suspense>
    </div >
  )
}

export default App
